"use strict";
/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomizedPrescribedActions = exports.getOrgAssessmentSummary = exports.getAssessmentFeatures = exports.getAssessmentTemplates = exports.getAssessments = exports.getCustomerAccounts = void 0;
exports.getCustomerAccounts = `
  query GetCustomerAccounts(
    $filter: CustomerAccountFilter!
    $limit: Int
    $nextToken: AWSJSON
  ) {
    getCustomerAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationId
        referenceId
        accountName
        ownerId
        createdBy
        updatedBy
        website
        industry
        region
        territory
        geo
        segment
        contacts {
          lastName
          firstName
          email
          title
        }
        assessmentsInfo {
          id
          organizationID
          status
          type
          version
          description
          deliveredRemotely
          isDemoTest
          workshopDate
          readoutDate
          mapProgramEngagementId
          opportunity {
            id
            name
          }
          engagement {
            id
            name
          }
          deliveredBy
          internalContact
          createAt
          createdBy
          updatedAt
          updatedBy
          isfavorite
          tags {
            key
            value
          }
          metadata {
            key
            value
          }
          optOutSolutionsRecommendation
          targetSegmentId
          sendAllPromptsToPreEvent
          customerCloudMaturity
          customerPlanAndAlignment
        }
      }
      nextToken
    }
  }
`;
exports.getAssessments = `
  query GetAssessments(
    $filter: AssessmentFilter
    $limit: Int
    $nextToken: AWSJSON
  ) {
    getAssessments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationID
        status
        type
        version
        description
        deliveredRemotely
        isDemoTest
        workshopDate
        readoutDate
        mapProgramEngagementId
        opportunity {
          id
          name
        }
        engagement {
          id
          name
        }
        deliveredBy
        internalContact
        createAt
        createdBy
        updatedAt
        updatedBy
        isfavorite
        tags {
          key
          value
        }
        metadata {
          key
          value
        }
        customerAccount {
          id
          organizationId
          referenceId
          accountName
          ownerId
          createdBy
          updatedBy
          website
          industry
          region
          territory
          geo
          segment
          contacts {
            lastName
            firstName
            email
            title
          }
          assessmentsInfo {
            id
            organizationID
            status
            type
            version
            description
            deliveredRemotely
            isDemoTest
            workshopDate
            readoutDate
            mapProgramEngagementId
            opportunity {
              id
              name
            }
            engagement {
              id
              name
            }
            deliveredBy
            internalContact
            createAt
            createdBy
            updatedAt
            updatedBy
            isfavorite
            tags {
              key
              value
            }
            metadata {
              key
              value
            }
            optOutSolutionsRecommendation
            targetSegmentId
            sendAllPromptsToPreEvent
            customerCloudMaturity
            customerPlanAndAlignment
          }
        }
        template {
          title
          applicationTitle
          description
          type
          version
          locale
          lastUpdated
          applicability {
            prompts {
              id
              label {
                label
                text
              }
              context {
                label
                text
              }
              hint {
                label
                text
              }
              responseType
              rating1
              rating2
              rating3
              rating4
              rating5
              responseSelections {
                selectionDescription
                selections {
                  selectionLabel
                  selectionId
                }
              }
            }
          }
          defaults {
            userQuestionnaires {
              preEvent {
                enabled
                questions {
                  optionToSendAll
                  excludeSections
                  questionType
                }
                sponsorEmailTemplate {
                  subject
                  body
                }
                participantEmailTemplate {
                  subject
                  body
                }
              }
            }
            questionnaireAnswers {
              perspective
              questionContextLabel
              questionLabel
              useQuestionRatingStratum
              ratingBands {
                color
                lowerBound
                upperBound
                title
                description
              }
              rating1
              rating1Disabled
              rating1Title
              rating1Value
              rating1Color
              rating2
              rating2Disabled
              rating2Title
              rating2Value
              rating2Color
              rating3
              rating3Disabled
              rating3Title
              rating3Value
              rating3Color
              rating4
              rating4Disabled
              rating4Title
              rating4Value
              rating4Color
              rating5
              rating5Disabled
              rating5Title
              rating5Value
              rating5Color
              ratingNA
              ratingNATitle
              ratingNAValue
              ratingNAEnabled
              ratingNAColor
              ratingIncompleteColor
              showGuidance
              useQuestionIndex
              minAnswersToScore
              wbsEnabled
              questionTypeEnabled
              metadataConfig {
                excludeOptionalMetadataKeys
                requiredMetadataKeys
                customMetadata {
                  key
                  keyName
                  keyDescription
                  valueType
                  valueHint
                  defaultValue
                  responseSelections {
                    selectionDescription
                    selections {
                      selectionLabel
                      selectionId
                    }
                  }
                }
              }
            }
            report {
              sectionLabel
              report {
                title
                description
                context
                type
                groupBy
                categoryLabel
                sectionLabel
                excludeSections
                useQuestionIndex
                disabled
              }
              heatmap {
                title
                description
                context
                type
                groupBy
                categoryLabel
                sectionLabel
                excludeSections
                useQuestionIndex
                disabled
              }
              scoreBarChart {
                title
                description
                context
                type
                groupBy
                categoryLabel
                sectionLabel
                excludeSections
                useQuestionIndex
                disabled
              }
              responseDistribution {
                title
                description
                context
                type
                groupBy
                categoryLabel
                sectionLabel
                excludeSections
                useQuestionIndex
                disabled
              }
              radar {
                title
                description
                context
                type
                groupBy
                categoryLabel
                sectionLabel
                excludeSections
                useQuestionIndex
                disabled
              }
              snapshots {
                title
                description
                context
                type
                groupBy
                categoryLabel
                sectionLabel
                excludeSections
                useQuestionIndex
                disabled
              }
              ppt {
                title
                description
                context
                type
                groupBy
                categoryLabel
                sectionLabel
                excludeSections
                useQuestionIndex
                disabled
              }
              word {
                title
                description
                context
                type
                groupBy
                categoryLabel
                sectionLabel
                excludeSections
                useQuestionIndex
                disabled
              }
              excel {
                title
                description
                context
                type
                groupBy
                categoryLabel
                sectionLabel
                excludeSections
                useQuestionIndex
                disabled
              }
              scores {
                maxRating
                perspectiveWeighted
                equalCategoryWeight
                summaryAssessment {
                  name
                  resultCriteria {
                    summary
                    description
                    ratingRange
                  }
                }
                ignoreIncomplete
              }
            }
          }
          sections {
            id
            label
            showIfAnswerYes
            categories {
              id
              name
              abbreviation
              ability {
                label
                text
              }
              driver {
                label
                text
              }
              prescribedActions {
                label
                text
              }
              observations {
                observations
                updatedBy
                tags {
                  key
                  value
                }
              }
              actions {
                actions {
                  text
                  priority
                  effort
                  targetDate
                  owner
                }
                updatedBy
                tags {
                  key
                  value
                }
              }
              prompts {
                id
                targetSegmentIds
                label {
                  label
                  text
                }
                abbreviation {
                  label
                  text
                }
                context {
                  label
                  text
                }
                hint {
                  label
                  text
                }
                customerRole
                artifact
                workstream {
                  id
                  name
                  accelerator
                  activities {
                    id
                    name
                    phase
                    prescribedActions {
                      label
                      text
                    }
                    observations {
                      observations
                      updatedBy
                      tags {
                        key
                        value
                      }
                    }
                    actions {
                      actions {
                        text
                        priority
                        effort
                        targetDate
                        owner
                      }
                      updatedBy
                      tags {
                        key
                        value
                      }
                    }
                    prompts {
                      id
                      targetSegmentIds
                      label {
                        label
                        text
                      }
                      abbreviation {
                        label
                        text
                      }
                      context {
                        label
                        text
                      }
                      hint {
                        label
                        text
                      }
                      customerRole
                      artifact
                      workstream {
                        id
                        name
                        accelerator
                        activities {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      dependencyActivity {
                        id
                        name
                        phase
                        prescribedActions {
                          label
                          text
                        }
                        observations {
                          observations
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        actions {
                          actions {
                            text
                            priority
                            effort
                            targetDate
                            owner
                          }
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        prompts {
                          id
                          targetSegmentIds
                          label {
                            label
                            text
                          }
                          abbreviation {
                            label
                            text
                          }
                          context {
                            label
                            text
                          }
                          hint {
                            label
                            text
                          }
                          customerRole
                          artifact
                          workstream {
                            id
                            name
                            accelerator
                            score
                          }
                          dependencyActivity {
                            id
                            name
                            phase
                            score
                          }
                          responseType
                          rating1
                          rating2
                          rating3
                          rating4
                          rating5
                          questionType
                          responseSelections {
                            selectionDescription
                          }
                          priority
                          response {
                            ... on AssessmentResponseText {
                              stringValue
                              priority
                              updatedBy
                            }
                            ... on AssessmentResponseRating {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseBoolean {
                              booleanValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseNumber {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseSingleSelection {
                              singleSelectValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseMultiSelection {
                              multiSelectValues
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseDate {
                              dateValue
                              priority
                              comments
                              updatedBy
                            }
                          }
                          metadata {
                            key
                            value
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      responseType
                      rating1
                      rating2
                      rating3
                      rating4
                      rating5
                      questionType
                      responseSelections {
                        selectionDescription
                        selections {
                          selectionLabel
                          selectionId
                        }
                      }
                      priority
                      response {
                        ... on AssessmentResponseText {
                          stringValue
                          priority
                          updatedBy
                        }
                        ... on AssessmentResponseRating {
                          intValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseBoolean {
                          booleanValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseNumber {
                          intValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseSingleSelection {
                          singleSelectValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseMultiSelection {
                          multiSelectValues
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseDate {
                          dateValue
                          priority
                          comments
                          updatedBy
                        }
                      }
                      metadata {
                        key
                        value
                      }
                    }
                    score
                    booleanDistribution {
                      numYes
                      numNo
                      numUnknown
                    }
                  }
                  score
                  booleanDistribution {
                    numYes
                    numNo
                    numUnknown
                  }
                }
                dependencyActivity {
                  id
                  name
                  phase
                  prescribedActions {
                    label
                    text
                  }
                  observations {
                    observations
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  actions {
                    actions {
                      text
                      priority
                      effort
                      targetDate
                      owner
                    }
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  prompts {
                    id
                    targetSegmentIds
                    label {
                      label
                      text
                    }
                    abbreviation {
                      label
                      text
                    }
                    context {
                      label
                      text
                    }
                    hint {
                      label
                      text
                    }
                    customerRole
                    artifact
                    workstream {
                      id
                      name
                      accelerator
                      activities {
                        id
                        name
                        phase
                        prescribedActions {
                          label
                          text
                        }
                        observations {
                          observations
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        actions {
                          actions {
                            text
                            priority
                            effort
                            targetDate
                            owner
                          }
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        prompts {
                          id
                          targetSegmentIds
                          label {
                            label
                            text
                          }
                          abbreviation {
                            label
                            text
                          }
                          context {
                            label
                            text
                          }
                          hint {
                            label
                            text
                          }
                          customerRole
                          artifact
                          workstream {
                            id
                            name
                            accelerator
                            score
                          }
                          dependencyActivity {
                            id
                            name
                            phase
                            score
                          }
                          responseType
                          rating1
                          rating2
                          rating3
                          rating4
                          rating5
                          questionType
                          responseSelections {
                            selectionDescription
                          }
                          priority
                          response {
                            ... on AssessmentResponseText {
                              stringValue
                              priority
                              updatedBy
                            }
                            ... on AssessmentResponseRating {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseBoolean {
                              booleanValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseNumber {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseSingleSelection {
                              singleSelectValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseMultiSelection {
                              multiSelectValues
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseDate {
                              dateValue
                              priority
                              comments
                              updatedBy
                            }
                          }
                          metadata {
                            key
                            value
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    dependencyActivity {
                      id
                      name
                      phase
                      prescribedActions {
                        label
                        text
                      }
                      observations {
                        observations
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      actions {
                        actions {
                          text
                          priority
                          effort
                          targetDate
                          owner
                        }
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      prompts {
                        id
                        targetSegmentIds
                        label {
                          label
                          text
                        }
                        abbreviation {
                          label
                          text
                        }
                        context {
                          label
                          text
                        }
                        hint {
                          label
                          text
                        }
                        customerRole
                        artifact
                        workstream {
                          id
                          name
                          accelerator
                          activities {
                            id
                            name
                            phase
                            score
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        dependencyActivity {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        responseType
                        rating1
                        rating2
                        rating3
                        rating4
                        rating5
                        questionType
                        responseSelections {
                          selectionDescription
                          selections {
                            selectionLabel
                            selectionId
                          }
                        }
                        priority
                        response {
                          ... on AssessmentResponseText {
                            stringValue
                            priority
                            updatedBy
                          }
                          ... on AssessmentResponseRating {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseBoolean {
                            booleanValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseNumber {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseSingleSelection {
                            singleSelectValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseMultiSelection {
                            multiSelectValues
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseDate {
                            dateValue
                            priority
                            comments
                            updatedBy
                          }
                        }
                        metadata {
                          key
                          value
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    responseType
                    rating1
                    rating2
                    rating3
                    rating4
                    rating5
                    questionType
                    responseSelections {
                      selectionDescription
                      selections {
                        selectionLabel
                        selectionId
                      }
                    }
                    priority
                    response {
                      ... on AssessmentResponseText {
                        stringValue
                        priority
                        updatedBy
                      }
                      ... on AssessmentResponseRating {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseBoolean {
                        booleanValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseNumber {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseSingleSelection {
                        singleSelectValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseMultiSelection {
                        multiSelectValues
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseDate {
                        dateValue
                        priority
                        comments
                        updatedBy
                      }
                    }
                    metadata {
                      key
                      value
                    }
                  }
                  score
                  booleanDistribution {
                    numYes
                    numNo
                    numUnknown
                  }
                }
                responseType
                rating1
                rating2
                rating3
                rating4
                rating5
                questionType
                responseSelections {
                  selectionDescription
                  selections {
                    selectionLabel
                    selectionId
                  }
                }
                priority
                response {
                  ... on AssessmentResponseText {
                    stringValue
                    priority
                    updatedBy
                  }
                  ... on AssessmentResponseRating {
                    intValue
                    priority
                    comments
                    updatedBy
                  }
                  ... on AssessmentResponseBoolean {
                    booleanValue
                    priority
                    comments
                    updatedBy
                  }
                  ... on AssessmentResponseNumber {
                    intValue
                    priority
                    comments
                    updatedBy
                  }
                  ... on AssessmentResponseSingleSelection {
                    singleSelectValue
                    priority
                    comments
                    updatedBy
                  }
                  ... on AssessmentResponseMultiSelection {
                    multiSelectValues
                    priority
                    comments
                    updatedBy
                  }
                  ... on AssessmentResponseDate {
                    dateValue
                    priority
                    comments
                    updatedBy
                  }
                }
                metadata {
                  key
                  value
                }
              }
              score
              weightedScore
              booleanDistribution {
                numYes
                numNo
                numUnknown
              }
            }
            abbreviation
            percentWeight
            score
            weightedScore
            booleanDistribution {
              numYes
              numNo
              numUnknown
            }
          }
          workstreams {
            id
            name
            accelerator
            activities {
              id
              name
              phase
              prescribedActions {
                label
                text
              }
              observations {
                observations
                updatedBy
                tags {
                  key
                  value
                }
              }
              actions {
                actions {
                  text
                  priority
                  effort
                  targetDate
                  owner
                }
                updatedBy
                tags {
                  key
                  value
                }
              }
              prompts {
                id
                targetSegmentIds
                label {
                  label
                  text
                }
                abbreviation {
                  label
                  text
                }
                context {
                  label
                  text
                }
                hint {
                  label
                  text
                }
                customerRole
                artifact
                workstream {
                  id
                  name
                  accelerator
                  activities {
                    id
                    name
                    phase
                    prescribedActions {
                      label
                      text
                    }
                    observations {
                      observations
                      updatedBy
                      tags {
                        key
                        value
                      }
                    }
                    actions {
                      actions {
                        text
                        priority
                        effort
                        targetDate
                        owner
                      }
                      updatedBy
                      tags {
                        key
                        value
                      }
                    }
                    prompts {
                      id
                      targetSegmentIds
                      label {
                        label
                        text
                      }
                      abbreviation {
                        label
                        text
                      }
                      context {
                        label
                        text
                      }
                      hint {
                        label
                        text
                      }
                      customerRole
                      artifact
                      workstream {
                        id
                        name
                        accelerator
                        activities {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      dependencyActivity {
                        id
                        name
                        phase
                        prescribedActions {
                          label
                          text
                        }
                        observations {
                          observations
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        actions {
                          actions {
                            text
                            priority
                            effort
                            targetDate
                            owner
                          }
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        prompts {
                          id
                          targetSegmentIds
                          label {
                            label
                            text
                          }
                          abbreviation {
                            label
                            text
                          }
                          context {
                            label
                            text
                          }
                          hint {
                            label
                            text
                          }
                          customerRole
                          artifact
                          workstream {
                            id
                            name
                            accelerator
                            score
                          }
                          dependencyActivity {
                            id
                            name
                            phase
                            score
                          }
                          responseType
                          rating1
                          rating2
                          rating3
                          rating4
                          rating5
                          questionType
                          responseSelections {
                            selectionDescription
                          }
                          priority
                          response {
                            ... on AssessmentResponseText {
                              stringValue
                              priority
                              updatedBy
                            }
                            ... on AssessmentResponseRating {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseBoolean {
                              booleanValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseNumber {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseSingleSelection {
                              singleSelectValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseMultiSelection {
                              multiSelectValues
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseDate {
                              dateValue
                              priority
                              comments
                              updatedBy
                            }
                          }
                          metadata {
                            key
                            value
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      responseType
                      rating1
                      rating2
                      rating3
                      rating4
                      rating5
                      questionType
                      responseSelections {
                        selectionDescription
                        selections {
                          selectionLabel
                          selectionId
                        }
                      }
                      priority
                      response {
                        ... on AssessmentResponseText {
                          stringValue
                          priority
                          updatedBy
                        }
                        ... on AssessmentResponseRating {
                          intValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseBoolean {
                          booleanValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseNumber {
                          intValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseSingleSelection {
                          singleSelectValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseMultiSelection {
                          multiSelectValues
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseDate {
                          dateValue
                          priority
                          comments
                          updatedBy
                        }
                      }
                      metadata {
                        key
                        value
                      }
                    }
                    score
                    booleanDistribution {
                      numYes
                      numNo
                      numUnknown
                    }
                  }
                  score
                  booleanDistribution {
                    numYes
                    numNo
                    numUnknown
                  }
                }
                dependencyActivity {
                  id
                  name
                  phase
                  prescribedActions {
                    label
                    text
                  }
                  observations {
                    observations
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  actions {
                    actions {
                      text
                      priority
                      effort
                      targetDate
                      owner
                    }
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  prompts {
                    id
                    targetSegmentIds
                    label {
                      label
                      text
                    }
                    abbreviation {
                      label
                      text
                    }
                    context {
                      label
                      text
                    }
                    hint {
                      label
                      text
                    }
                    customerRole
                    artifact
                    workstream {
                      id
                      name
                      accelerator
                      activities {
                        id
                        name
                        phase
                        prescribedActions {
                          label
                          text
                        }
                        observations {
                          observations
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        actions {
                          actions {
                            text
                            priority
                            effort
                            targetDate
                            owner
                          }
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        prompts {
                          id
                          targetSegmentIds
                          label {
                            label
                            text
                          }
                          abbreviation {
                            label
                            text
                          }
                          context {
                            label
                            text
                          }
                          hint {
                            label
                            text
                          }
                          customerRole
                          artifact
                          workstream {
                            id
                            name
                            accelerator
                            score
                          }
                          dependencyActivity {
                            id
                            name
                            phase
                            score
                          }
                          responseType
                          rating1
                          rating2
                          rating3
                          rating4
                          rating5
                          questionType
                          responseSelections {
                            selectionDescription
                          }
                          priority
                          response {
                            ... on AssessmentResponseText {
                              stringValue
                              priority
                              updatedBy
                            }
                            ... on AssessmentResponseRating {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseBoolean {
                              booleanValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseNumber {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseSingleSelection {
                              singleSelectValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseMultiSelection {
                              multiSelectValues
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseDate {
                              dateValue
                              priority
                              comments
                              updatedBy
                            }
                          }
                          metadata {
                            key
                            value
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    dependencyActivity {
                      id
                      name
                      phase
                      prescribedActions {
                        label
                        text
                      }
                      observations {
                        observations
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      actions {
                        actions {
                          text
                          priority
                          effort
                          targetDate
                          owner
                        }
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      prompts {
                        id
                        targetSegmentIds
                        label {
                          label
                          text
                        }
                        abbreviation {
                          label
                          text
                        }
                        context {
                          label
                          text
                        }
                        hint {
                          label
                          text
                        }
                        customerRole
                        artifact
                        workstream {
                          id
                          name
                          accelerator
                          activities {
                            id
                            name
                            phase
                            score
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        dependencyActivity {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        responseType
                        rating1
                        rating2
                        rating3
                        rating4
                        rating5
                        questionType
                        responseSelections {
                          selectionDescription
                          selections {
                            selectionLabel
                            selectionId
                          }
                        }
                        priority
                        response {
                          ... on AssessmentResponseText {
                            stringValue
                            priority
                            updatedBy
                          }
                          ... on AssessmentResponseRating {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseBoolean {
                            booleanValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseNumber {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseSingleSelection {
                            singleSelectValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseMultiSelection {
                            multiSelectValues
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseDate {
                            dateValue
                            priority
                            comments
                            updatedBy
                          }
                        }
                        metadata {
                          key
                          value
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    responseType
                    rating1
                    rating2
                    rating3
                    rating4
                    rating5
                    questionType
                    responseSelections {
                      selectionDescription
                      selections {
                        selectionLabel
                        selectionId
                      }
                    }
                    priority
                    response {
                      ... on AssessmentResponseText {
                        stringValue
                        priority
                        updatedBy
                      }
                      ... on AssessmentResponseRating {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseBoolean {
                        booleanValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseNumber {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseSingleSelection {
                        singleSelectValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseMultiSelection {
                        multiSelectValues
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseDate {
                        dateValue
                        priority
                        comments
                        updatedBy
                      }
                    }
                    metadata {
                      key
                      value
                    }
                  }
                  score
                  booleanDistribution {
                    numYes
                    numNo
                    numUnknown
                  }
                }
                responseType
                rating1
                rating2
                rating3
                rating4
                rating5
                questionType
                responseSelections {
                  selectionDescription
                  selections {
                    selectionLabel
                    selectionId
                  }
                }
                priority
                response {
                  ... on AssessmentResponseText {
                    stringValue
                    priority
                    updatedBy
                  }
                  ... on AssessmentResponseRating {
                    intValue
                    priority
                    comments
                    updatedBy
                  }
                  ... on AssessmentResponseBoolean {
                    booleanValue
                    priority
                    comments
                    updatedBy
                  }
                  ... on AssessmentResponseNumber {
                    intValue
                    priority
                    comments
                    updatedBy
                  }
                  ... on AssessmentResponseSingleSelection {
                    singleSelectValue
                    priority
                    comments
                    updatedBy
                  }
                  ... on AssessmentResponseMultiSelection {
                    multiSelectValues
                    priority
                    comments
                    updatedBy
                  }
                  ... on AssessmentResponseDate {
                    dateValue
                    priority
                    comments
                    updatedBy
                  }
                }
                metadata {
                  key
                  value
                }
              }
              score
              booleanDistribution {
                numYes
                numNo
                numUnknown
              }
            }
            score
            booleanDistribution {
              numYes
              numNo
              numUnknown
            }
          }
          progress
          score
          booleanDistribution {
            numYes
            numNo
            numUnknown
          }
          deliveryGuidance {
            description
            learnMore
          }
          metadataConfig {
            excludeOptionalMetadataKeys
            requiredMetadataKeys
            customMetadata {
              key
              keyName
              keyDescription
              valueType
              valueHint
              defaultValue
              responseSelections {
                selectionDescription
                selections {
                  selectionLabel
                  selectionId
                }
              }
            }
          }
        }
        permissions {
          isPending
          invitationId
          userId
          action
          createdBy
          createdAt
          inviteeEmail
        }
        snapshotConnection {
          snapshots {
            id
            description
            createdAt
            createdBy
            template {
              title
              applicationTitle
              description
              type
              version
              locale
              lastUpdated
              applicability {
                prompts {
                  id
                  label {
                    label
                    text
                  }
                  context {
                    label
                    text
                  }
                  hint {
                    label
                    text
                  }
                  responseType
                  rating1
                  rating2
                  rating3
                  rating4
                  rating5
                  responseSelections {
                    selectionDescription
                    selections {
                      selectionLabel
                      selectionId
                    }
                  }
                }
              }
              defaults {
                userQuestionnaires {
                  preEvent {
                    enabled
                    questions {
                      optionToSendAll
                      excludeSections
                      questionType
                    }
                    sponsorEmailTemplate {
                      subject
                      body
                    }
                    participantEmailTemplate {
                      subject
                      body
                    }
                  }
                }
                questionnaireAnswers {
                  perspective
                  questionContextLabel
                  questionLabel
                  useQuestionRatingStratum
                  ratingBands {
                    color
                    lowerBound
                    upperBound
                    title
                    description
                  }
                  rating1
                  rating1Disabled
                  rating1Title
                  rating1Value
                  rating1Color
                  rating2
                  rating2Disabled
                  rating2Title
                  rating2Value
                  rating2Color
                  rating3
                  rating3Disabled
                  rating3Title
                  rating3Value
                  rating3Color
                  rating4
                  rating4Disabled
                  rating4Title
                  rating4Value
                  rating4Color
                  rating5
                  rating5Disabled
                  rating5Title
                  rating5Value
                  rating5Color
                  ratingNA
                  ratingNATitle
                  ratingNAValue
                  ratingNAEnabled
                  ratingNAColor
                  ratingIncompleteColor
                  showGuidance
                  useQuestionIndex
                  minAnswersToScore
                  wbsEnabled
                  questionTypeEnabled
                  metadataConfig {
                    excludeOptionalMetadataKeys
                    requiredMetadataKeys
                    customMetadata {
                      key
                      keyName
                      keyDescription
                      valueType
                      valueHint
                      defaultValue
                      responseSelections {
                        selectionDescription
                        selections {
                          selectionLabel
                          selectionId
                        }
                      }
                    }
                  }
                }
                report {
                  sectionLabel
                  report {
                    title
                    description
                    context
                    type
                    groupBy
                    categoryLabel
                    sectionLabel
                    excludeSections
                    useQuestionIndex
                    disabled
                  }
                  heatmap {
                    title
                    description
                    context
                    type
                    groupBy
                    categoryLabel
                    sectionLabel
                    excludeSections
                    useQuestionIndex
                    disabled
                  }
                  scoreBarChart {
                    title
                    description
                    context
                    type
                    groupBy
                    categoryLabel
                    sectionLabel
                    excludeSections
                    useQuestionIndex
                    disabled
                  }
                  responseDistribution {
                    title
                    description
                    context
                    type
                    groupBy
                    categoryLabel
                    sectionLabel
                    excludeSections
                    useQuestionIndex
                    disabled
                  }
                  radar {
                    title
                    description
                    context
                    type
                    groupBy
                    categoryLabel
                    sectionLabel
                    excludeSections
                    useQuestionIndex
                    disabled
                  }
                  snapshots {
                    title
                    description
                    context
                    type
                    groupBy
                    categoryLabel
                    sectionLabel
                    excludeSections
                    useQuestionIndex
                    disabled
                  }
                  ppt {
                    title
                    description
                    context
                    type
                    groupBy
                    categoryLabel
                    sectionLabel
                    excludeSections
                    useQuestionIndex
                    disabled
                  }
                  word {
                    title
                    description
                    context
                    type
                    groupBy
                    categoryLabel
                    sectionLabel
                    excludeSections
                    useQuestionIndex
                    disabled
                  }
                  excel {
                    title
                    description
                    context
                    type
                    groupBy
                    categoryLabel
                    sectionLabel
                    excludeSections
                    useQuestionIndex
                    disabled
                  }
                  scores {
                    maxRating
                    perspectiveWeighted
                    equalCategoryWeight
                    summaryAssessment {
                      name
                      resultCriteria {
                        summary
                        description
                        ratingRange
                      }
                    }
                    ignoreIncomplete
                  }
                }
              }
              sections {
                id
                label
                showIfAnswerYes
                categories {
                  id
                  name
                  abbreviation
                  ability {
                    label
                    text
                  }
                  driver {
                    label
                    text
                  }
                  prescribedActions {
                    label
                    text
                  }
                  observations {
                    observations
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  actions {
                    actions {
                      text
                      priority
                      effort
                      targetDate
                      owner
                    }
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  prompts {
                    id
                    targetSegmentIds
                    label {
                      label
                      text
                    }
                    abbreviation {
                      label
                      text
                    }
                    context {
                      label
                      text
                    }
                    hint {
                      label
                      text
                    }
                    customerRole
                    artifact
                    workstream {
                      id
                      name
                      accelerator
                      activities {
                        id
                        name
                        phase
                        prescribedActions {
                          label
                          text
                        }
                        observations {
                          observations
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        actions {
                          actions {
                            text
                            priority
                            effort
                            targetDate
                            owner
                          }
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        prompts {
                          id
                          targetSegmentIds
                          label {
                            label
                            text
                          }
                          abbreviation {
                            label
                            text
                          }
                          context {
                            label
                            text
                          }
                          hint {
                            label
                            text
                          }
                          customerRole
                          artifact
                          workstream {
                            id
                            name
                            accelerator
                            score
                          }
                          dependencyActivity {
                            id
                            name
                            phase
                            score
                          }
                          responseType
                          rating1
                          rating2
                          rating3
                          rating4
                          rating5
                          questionType
                          responseSelections {
                            selectionDescription
                          }
                          priority
                          response {
                            ... on AssessmentResponseText {
                              stringValue
                              priority
                              updatedBy
                            }
                            ... on AssessmentResponseRating {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseBoolean {
                              booleanValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseNumber {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseSingleSelection {
                              singleSelectValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseMultiSelection {
                              multiSelectValues
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseDate {
                              dateValue
                              priority
                              comments
                              updatedBy
                            }
                          }
                          metadata {
                            key
                            value
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    dependencyActivity {
                      id
                      name
                      phase
                      prescribedActions {
                        label
                        text
                      }
                      observations {
                        observations
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      actions {
                        actions {
                          text
                          priority
                          effort
                          targetDate
                          owner
                        }
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      prompts {
                        id
                        targetSegmentIds
                        label {
                          label
                          text
                        }
                        abbreviation {
                          label
                          text
                        }
                        context {
                          label
                          text
                        }
                        hint {
                          label
                          text
                        }
                        customerRole
                        artifact
                        workstream {
                          id
                          name
                          accelerator
                          activities {
                            id
                            name
                            phase
                            score
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        dependencyActivity {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        responseType
                        rating1
                        rating2
                        rating3
                        rating4
                        rating5
                        questionType
                        responseSelections {
                          selectionDescription
                          selections {
                            selectionLabel
                            selectionId
                          }
                        }
                        priority
                        response {
                          ... on AssessmentResponseText {
                            stringValue
                            priority
                            updatedBy
                          }
                          ... on AssessmentResponseRating {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseBoolean {
                            booleanValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseNumber {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseSingleSelection {
                            singleSelectValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseMultiSelection {
                            multiSelectValues
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseDate {
                            dateValue
                            priority
                            comments
                            updatedBy
                          }
                        }
                        metadata {
                          key
                          value
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    responseType
                    rating1
                    rating2
                    rating3
                    rating4
                    rating5
                    questionType
                    responseSelections {
                      selectionDescription
                      selections {
                        selectionLabel
                        selectionId
                      }
                    }
                    priority
                    response {
                      ... on AssessmentResponseText {
                        stringValue
                        priority
                        updatedBy
                      }
                      ... on AssessmentResponseRating {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseBoolean {
                        booleanValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseNumber {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseSingleSelection {
                        singleSelectValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseMultiSelection {
                        multiSelectValues
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseDate {
                        dateValue
                        priority
                        comments
                        updatedBy
                      }
                    }
                    metadata {
                      key
                      value
                    }
                  }
                  score
                  weightedScore
                  booleanDistribution {
                    numYes
                    numNo
                    numUnknown
                  }
                }
                abbreviation
                percentWeight
                score
                weightedScore
                booleanDistribution {
                  numYes
                  numNo
                  numUnknown
                }
              }
              workstreams {
                id
                name
                accelerator
                activities {
                  id
                  name
                  phase
                  prescribedActions {
                    label
                    text
                  }
                  observations {
                    observations
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  actions {
                    actions {
                      text
                      priority
                      effort
                      targetDate
                      owner
                    }
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  prompts {
                    id
                    targetSegmentIds
                    label {
                      label
                      text
                    }
                    abbreviation {
                      label
                      text
                    }
                    context {
                      label
                      text
                    }
                    hint {
                      label
                      text
                    }
                    customerRole
                    artifact
                    workstream {
                      id
                      name
                      accelerator
                      activities {
                        id
                        name
                        phase
                        prescribedActions {
                          label
                          text
                        }
                        observations {
                          observations
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        actions {
                          actions {
                            text
                            priority
                            effort
                            targetDate
                            owner
                          }
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        prompts {
                          id
                          targetSegmentIds
                          label {
                            label
                            text
                          }
                          abbreviation {
                            label
                            text
                          }
                          context {
                            label
                            text
                          }
                          hint {
                            label
                            text
                          }
                          customerRole
                          artifact
                          workstream {
                            id
                            name
                            accelerator
                            score
                          }
                          dependencyActivity {
                            id
                            name
                            phase
                            score
                          }
                          responseType
                          rating1
                          rating2
                          rating3
                          rating4
                          rating5
                          questionType
                          responseSelections {
                            selectionDescription
                          }
                          priority
                          response {
                            ... on AssessmentResponseText {
                              stringValue
                              priority
                              updatedBy
                            }
                            ... on AssessmentResponseRating {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseBoolean {
                              booleanValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseNumber {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseSingleSelection {
                              singleSelectValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseMultiSelection {
                              multiSelectValues
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseDate {
                              dateValue
                              priority
                              comments
                              updatedBy
                            }
                          }
                          metadata {
                            key
                            value
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    dependencyActivity {
                      id
                      name
                      phase
                      prescribedActions {
                        label
                        text
                      }
                      observations {
                        observations
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      actions {
                        actions {
                          text
                          priority
                          effort
                          targetDate
                          owner
                        }
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      prompts {
                        id
                        targetSegmentIds
                        label {
                          label
                          text
                        }
                        abbreviation {
                          label
                          text
                        }
                        context {
                          label
                          text
                        }
                        hint {
                          label
                          text
                        }
                        customerRole
                        artifact
                        workstream {
                          id
                          name
                          accelerator
                          activities {
                            id
                            name
                            phase
                            score
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        dependencyActivity {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        responseType
                        rating1
                        rating2
                        rating3
                        rating4
                        rating5
                        questionType
                        responseSelections {
                          selectionDescription
                          selections {
                            selectionLabel
                            selectionId
                          }
                        }
                        priority
                        response {
                          ... on AssessmentResponseText {
                            stringValue
                            priority
                            updatedBy
                          }
                          ... on AssessmentResponseRating {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseBoolean {
                            booleanValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseNumber {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseSingleSelection {
                            singleSelectValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseMultiSelection {
                            multiSelectValues
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseDate {
                            dateValue
                            priority
                            comments
                            updatedBy
                          }
                        }
                        metadata {
                          key
                          value
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    responseType
                    rating1
                    rating2
                    rating3
                    rating4
                    rating5
                    questionType
                    responseSelections {
                      selectionDescription
                      selections {
                        selectionLabel
                        selectionId
                      }
                    }
                    priority
                    response {
                      ... on AssessmentResponseText {
                        stringValue
                        priority
                        updatedBy
                      }
                      ... on AssessmentResponseRating {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseBoolean {
                        booleanValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseNumber {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseSingleSelection {
                        singleSelectValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseMultiSelection {
                        multiSelectValues
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseDate {
                        dateValue
                        priority
                        comments
                        updatedBy
                      }
                    }
                    metadata {
                      key
                      value
                    }
                  }
                  score
                  booleanDistribution {
                    numYes
                    numNo
                    numUnknown
                  }
                }
                score
                booleanDistribution {
                  numYes
                  numNo
                  numUnknown
                }
              }
              progress
              score
              booleanDistribution {
                numYes
                numNo
                numUnknown
              }
              deliveryGuidance {
                description
                learnMore
              }
              metadataConfig {
                excludeOptionalMetadataKeys
                requiredMetadataKeys
                customMetadata {
                  key
                  keyName
                  keyDescription
                  valueType
                  valueHint
                  defaultValue
                  responseSelections {
                    selectionDescription
                    selections {
                      selectionLabel
                      selectionId
                    }
                  }
                }
              }
            }
          }
          nextPage
        }
        assessmentScores {
          scoreType
          scoreDetails
        }
        optOutSolutionsRecommendation
        targetSegmentId
        sendAllPromptsToPreEvent
        customerCloudMaturity
        customerPlanAndAlignment
      }
      nextToken
    }
  }
`;
exports.getAssessmentTemplates = `
  query GetAssessmentTemplates(
    $filter: AssessmentTemplateFilter
    $limit: Int
    $nextToken: AWSJSON
  ) {
    getAssessmentTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        title
        applicationTitle
        description
        type
        version
        locale
        lastUpdated
        applicability {
          prompts {
            id
            label {
              label
              text
            }
            context {
              label
              text
            }
            hint {
              label
              text
            }
            responseType
            rating1
            rating2
            rating3
            rating4
            rating5
            responseSelections {
              selectionDescription
              selections {
                selectionLabel
                selectionId
              }
            }
          }
        }
        defaults {
          userQuestionnaires {
            preEvent {
              enabled
              questions {
                optionToSendAll
                excludeSections
                questionType
              }
              sponsorEmailTemplate {
                subject
                body
              }
              participantEmailTemplate {
                subject
                body
              }
            }
          }
          questionnaireAnswers {
            perspective
            questionContextLabel
            questionLabel
            useQuestionRatingStratum
            ratingBands {
              color
              lowerBound
              upperBound
              title
              description
            }
            rating1
            rating1Disabled
            rating1Title
            rating1Value
            rating1Color
            rating2
            rating2Disabled
            rating2Title
            rating2Value
            rating2Color
            rating3
            rating3Disabled
            rating3Title
            rating3Value
            rating3Color
            rating4
            rating4Disabled
            rating4Title
            rating4Value
            rating4Color
            rating5
            rating5Disabled
            rating5Title
            rating5Value
            rating5Color
            ratingNA
            ratingNATitle
            ratingNAValue
            ratingNAEnabled
            ratingNAColor
            ratingIncompleteColor
            showGuidance
            useQuestionIndex
            minAnswersToScore
            wbsEnabled
            questionTypeEnabled
            metadataConfig {
              excludeOptionalMetadataKeys
              requiredMetadataKeys
              customMetadata {
                key
                keyName
                keyDescription
                valueType
                valueHint
                defaultValue
                responseSelections {
                  selectionDescription
                  selections {
                    selectionLabel
                    selectionId
                  }
                }
              }
            }
          }
          report {
            sectionLabel
            report {
              title
              description
              context
              type
              groupBy
              categoryLabel
              sectionLabel
              excludeSections
              useQuestionIndex
              disabled
            }
            heatmap {
              title
              description
              context
              type
              groupBy
              categoryLabel
              sectionLabel
              excludeSections
              useQuestionIndex
              disabled
            }
            scoreBarChart {
              title
              description
              context
              type
              groupBy
              categoryLabel
              sectionLabel
              excludeSections
              useQuestionIndex
              disabled
            }
            responseDistribution {
              title
              description
              context
              type
              groupBy
              categoryLabel
              sectionLabel
              excludeSections
              useQuestionIndex
              disabled
            }
            radar {
              title
              description
              context
              type
              groupBy
              categoryLabel
              sectionLabel
              excludeSections
              useQuestionIndex
              disabled
            }
            snapshots {
              title
              description
              context
              type
              groupBy
              categoryLabel
              sectionLabel
              excludeSections
              useQuestionIndex
              disabled
            }
            ppt {
              title
              description
              context
              type
              groupBy
              categoryLabel
              sectionLabel
              excludeSections
              useQuestionIndex
              disabled
            }
            word {
              title
              description
              context
              type
              groupBy
              categoryLabel
              sectionLabel
              excludeSections
              useQuestionIndex
              disabled
            }
            excel {
              title
              description
              context
              type
              groupBy
              categoryLabel
              sectionLabel
              excludeSections
              useQuestionIndex
              disabled
            }
            scores {
              maxRating
              perspectiveWeighted
              equalCategoryWeight
              summaryAssessment {
                name
                resultCriteria {
                  summary
                  description
                  ratingRange
                }
              }
              ignoreIncomplete
            }
          }
        }
        sections {
          id
          label
          showIfAnswerYes
          categories {
            id
            name
            abbreviation
            ability {
              label
              text
            }
            driver {
              label
              text
            }
            prescribedActions {
              label
              text
            }
            observations {
              observations
              updatedBy
              tags {
                key
                value
              }
            }
            actions {
              actions {
                text
                priority
                effort
                targetDate
                owner
              }
              updatedBy
              tags {
                key
                value
              }
            }
            prompts {
              id
              targetSegmentIds
              label {
                label
                text
              }
              abbreviation {
                label
                text
              }
              context {
                label
                text
              }
              hint {
                label
                text
              }
              customerRole
              artifact
              workstream {
                id
                name
                accelerator
                activities {
                  id
                  name
                  phase
                  prescribedActions {
                    label
                    text
                  }
                  observations {
                    observations
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  actions {
                    actions {
                      text
                      priority
                      effort
                      targetDate
                      owner
                    }
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  prompts {
                    id
                    targetSegmentIds
                    label {
                      label
                      text
                    }
                    abbreviation {
                      label
                      text
                    }
                    context {
                      label
                      text
                    }
                    hint {
                      label
                      text
                    }
                    customerRole
                    artifact
                    workstream {
                      id
                      name
                      accelerator
                      activities {
                        id
                        name
                        phase
                        prescribedActions {
                          label
                          text
                        }
                        observations {
                          observations
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        actions {
                          actions {
                            text
                            priority
                            effort
                            targetDate
                            owner
                          }
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        prompts {
                          id
                          targetSegmentIds
                          label {
                            label
                            text
                          }
                          abbreviation {
                            label
                            text
                          }
                          context {
                            label
                            text
                          }
                          hint {
                            label
                            text
                          }
                          customerRole
                          artifact
                          workstream {
                            id
                            name
                            accelerator
                            score
                          }
                          dependencyActivity {
                            id
                            name
                            phase
                            score
                          }
                          responseType
                          rating1
                          rating2
                          rating3
                          rating4
                          rating5
                          questionType
                          responseSelections {
                            selectionDescription
                          }
                          priority
                          response {
                            ... on AssessmentResponseText {
                              stringValue
                              priority
                              updatedBy
                            }
                            ... on AssessmentResponseRating {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseBoolean {
                              booleanValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseNumber {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseSingleSelection {
                              singleSelectValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseMultiSelection {
                              multiSelectValues
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseDate {
                              dateValue
                              priority
                              comments
                              updatedBy
                            }
                          }
                          metadata {
                            key
                            value
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    dependencyActivity {
                      id
                      name
                      phase
                      prescribedActions {
                        label
                        text
                      }
                      observations {
                        observations
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      actions {
                        actions {
                          text
                          priority
                          effort
                          targetDate
                          owner
                        }
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      prompts {
                        id
                        targetSegmentIds
                        label {
                          label
                          text
                        }
                        abbreviation {
                          label
                          text
                        }
                        context {
                          label
                          text
                        }
                        hint {
                          label
                          text
                        }
                        customerRole
                        artifact
                        workstream {
                          id
                          name
                          accelerator
                          activities {
                            id
                            name
                            phase
                            score
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        dependencyActivity {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        responseType
                        rating1
                        rating2
                        rating3
                        rating4
                        rating5
                        questionType
                        responseSelections {
                          selectionDescription
                          selections {
                            selectionLabel
                            selectionId
                          }
                        }
                        priority
                        response {
                          ... on AssessmentResponseText {
                            stringValue
                            priority
                            updatedBy
                          }
                          ... on AssessmentResponseRating {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseBoolean {
                            booleanValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseNumber {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseSingleSelection {
                            singleSelectValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseMultiSelection {
                            multiSelectValues
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseDate {
                            dateValue
                            priority
                            comments
                            updatedBy
                          }
                        }
                        metadata {
                          key
                          value
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    responseType
                    rating1
                    rating2
                    rating3
                    rating4
                    rating5
                    questionType
                    responseSelections {
                      selectionDescription
                      selections {
                        selectionLabel
                        selectionId
                      }
                    }
                    priority
                    response {
                      ... on AssessmentResponseText {
                        stringValue
                        priority
                        updatedBy
                      }
                      ... on AssessmentResponseRating {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseBoolean {
                        booleanValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseNumber {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseSingleSelection {
                        singleSelectValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseMultiSelection {
                        multiSelectValues
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseDate {
                        dateValue
                        priority
                        comments
                        updatedBy
                      }
                    }
                    metadata {
                      key
                      value
                    }
                  }
                  score
                  booleanDistribution {
                    numYes
                    numNo
                    numUnknown
                  }
                }
                score
                booleanDistribution {
                  numYes
                  numNo
                  numUnknown
                }
              }
              dependencyActivity {
                id
                name
                phase
                prescribedActions {
                  label
                  text
                }
                observations {
                  observations
                  updatedBy
                  tags {
                    key
                    value
                  }
                }
                actions {
                  actions {
                    text
                    priority
                    effort
                    targetDate
                    owner
                  }
                  updatedBy
                  tags {
                    key
                    value
                  }
                }
                prompts {
                  id
                  targetSegmentIds
                  label {
                    label
                    text
                  }
                  abbreviation {
                    label
                    text
                  }
                  context {
                    label
                    text
                  }
                  hint {
                    label
                    text
                  }
                  customerRole
                  artifact
                  workstream {
                    id
                    name
                    accelerator
                    activities {
                      id
                      name
                      phase
                      prescribedActions {
                        label
                        text
                      }
                      observations {
                        observations
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      actions {
                        actions {
                          text
                          priority
                          effort
                          targetDate
                          owner
                        }
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      prompts {
                        id
                        targetSegmentIds
                        label {
                          label
                          text
                        }
                        abbreviation {
                          label
                          text
                        }
                        context {
                          label
                          text
                        }
                        hint {
                          label
                          text
                        }
                        customerRole
                        artifact
                        workstream {
                          id
                          name
                          accelerator
                          activities {
                            id
                            name
                            phase
                            score
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        dependencyActivity {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        responseType
                        rating1
                        rating2
                        rating3
                        rating4
                        rating5
                        questionType
                        responseSelections {
                          selectionDescription
                          selections {
                            selectionLabel
                            selectionId
                          }
                        }
                        priority
                        response {
                          ... on AssessmentResponseText {
                            stringValue
                            priority
                            updatedBy
                          }
                          ... on AssessmentResponseRating {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseBoolean {
                            booleanValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseNumber {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseSingleSelection {
                            singleSelectValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseMultiSelection {
                            multiSelectValues
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseDate {
                            dateValue
                            priority
                            comments
                            updatedBy
                          }
                        }
                        metadata {
                          key
                          value
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    score
                    booleanDistribution {
                      numYes
                      numNo
                      numUnknown
                    }
                  }
                  dependencyActivity {
                    id
                    name
                    phase
                    prescribedActions {
                      label
                      text
                    }
                    observations {
                      observations
                      updatedBy
                      tags {
                        key
                        value
                      }
                    }
                    actions {
                      actions {
                        text
                        priority
                        effort
                        targetDate
                        owner
                      }
                      updatedBy
                      tags {
                        key
                        value
                      }
                    }
                    prompts {
                      id
                      targetSegmentIds
                      label {
                        label
                        text
                      }
                      abbreviation {
                        label
                        text
                      }
                      context {
                        label
                        text
                      }
                      hint {
                        label
                        text
                      }
                      customerRole
                      artifact
                      workstream {
                        id
                        name
                        accelerator
                        activities {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      dependencyActivity {
                        id
                        name
                        phase
                        prescribedActions {
                          label
                          text
                        }
                        observations {
                          observations
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        actions {
                          actions {
                            text
                            priority
                            effort
                            targetDate
                            owner
                          }
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        prompts {
                          id
                          targetSegmentIds
                          label {
                            label
                            text
                          }
                          abbreviation {
                            label
                            text
                          }
                          context {
                            label
                            text
                          }
                          hint {
                            label
                            text
                          }
                          customerRole
                          artifact
                          workstream {
                            id
                            name
                            accelerator
                            score
                          }
                          dependencyActivity {
                            id
                            name
                            phase
                            score
                          }
                          responseType
                          rating1
                          rating2
                          rating3
                          rating4
                          rating5
                          questionType
                          responseSelections {
                            selectionDescription
                          }
                          priority
                          response {
                            ... on AssessmentResponseText {
                              stringValue
                              priority
                              updatedBy
                            }
                            ... on AssessmentResponseRating {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseBoolean {
                              booleanValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseNumber {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseSingleSelection {
                              singleSelectValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseMultiSelection {
                              multiSelectValues
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseDate {
                              dateValue
                              priority
                              comments
                              updatedBy
                            }
                          }
                          metadata {
                            key
                            value
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      responseType
                      rating1
                      rating2
                      rating3
                      rating4
                      rating5
                      questionType
                      responseSelections {
                        selectionDescription
                        selections {
                          selectionLabel
                          selectionId
                        }
                      }
                      priority
                      response {
                        ... on AssessmentResponseText {
                          stringValue
                          priority
                          updatedBy
                        }
                        ... on AssessmentResponseRating {
                          intValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseBoolean {
                          booleanValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseNumber {
                          intValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseSingleSelection {
                          singleSelectValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseMultiSelection {
                          multiSelectValues
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseDate {
                          dateValue
                          priority
                          comments
                          updatedBy
                        }
                      }
                      metadata {
                        key
                        value
                      }
                    }
                    score
                    booleanDistribution {
                      numYes
                      numNo
                      numUnknown
                    }
                  }
                  responseType
                  rating1
                  rating2
                  rating3
                  rating4
                  rating5
                  questionType
                  responseSelections {
                    selectionDescription
                    selections {
                      selectionLabel
                      selectionId
                    }
                  }
                  priority
                  response {
                    ... on AssessmentResponseText {
                      stringValue
                      priority
                      updatedBy
                    }
                    ... on AssessmentResponseRating {
                      intValue
                      priority
                      comments
                      updatedBy
                    }
                    ... on AssessmentResponseBoolean {
                      booleanValue
                      priority
                      comments
                      updatedBy
                    }
                    ... on AssessmentResponseNumber {
                      intValue
                      priority
                      comments
                      updatedBy
                    }
                    ... on AssessmentResponseSingleSelection {
                      singleSelectValue
                      priority
                      comments
                      updatedBy
                    }
                    ... on AssessmentResponseMultiSelection {
                      multiSelectValues
                      priority
                      comments
                      updatedBy
                    }
                    ... on AssessmentResponseDate {
                      dateValue
                      priority
                      comments
                      updatedBy
                    }
                  }
                  metadata {
                    key
                    value
                  }
                }
                score
                booleanDistribution {
                  numYes
                  numNo
                  numUnknown
                }
              }
              responseType
              rating1
              rating2
              rating3
              rating4
              rating5
              questionType
              responseSelections {
                selectionDescription
                selections {
                  selectionLabel
                  selectionId
                }
              }
              priority
              response {
                ... on AssessmentResponseText {
                  stringValue
                  priority
                  updatedBy
                }
                ... on AssessmentResponseRating {
                  intValue
                  priority
                  comments
                  updatedBy
                }
                ... on AssessmentResponseBoolean {
                  booleanValue
                  priority
                  comments
                  updatedBy
                }
                ... on AssessmentResponseNumber {
                  intValue
                  priority
                  comments
                  updatedBy
                }
                ... on AssessmentResponseSingleSelection {
                  singleSelectValue
                  priority
                  comments
                  updatedBy
                }
                ... on AssessmentResponseMultiSelection {
                  multiSelectValues
                  priority
                  comments
                  updatedBy
                }
                ... on AssessmentResponseDate {
                  dateValue
                  priority
                  comments
                  updatedBy
                }
              }
              metadata {
                key
                value
              }
            }
            score
            weightedScore
            booleanDistribution {
              numYes
              numNo
              numUnknown
            }
          }
          abbreviation
          percentWeight
          score
          weightedScore
          booleanDistribution {
            numYes
            numNo
            numUnknown
          }
        }
        workstreams {
          id
          name
          accelerator
          activities {
            id
            name
            phase
            prescribedActions {
              label
              text
            }
            observations {
              observations
              updatedBy
              tags {
                key
                value
              }
            }
            actions {
              actions {
                text
                priority
                effort
                targetDate
                owner
              }
              updatedBy
              tags {
                key
                value
              }
            }
            prompts {
              id
              targetSegmentIds
              label {
                label
                text
              }
              abbreviation {
                label
                text
              }
              context {
                label
                text
              }
              hint {
                label
                text
              }
              customerRole
              artifact
              workstream {
                id
                name
                accelerator
                activities {
                  id
                  name
                  phase
                  prescribedActions {
                    label
                    text
                  }
                  observations {
                    observations
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  actions {
                    actions {
                      text
                      priority
                      effort
                      targetDate
                      owner
                    }
                    updatedBy
                    tags {
                      key
                      value
                    }
                  }
                  prompts {
                    id
                    targetSegmentIds
                    label {
                      label
                      text
                    }
                    abbreviation {
                      label
                      text
                    }
                    context {
                      label
                      text
                    }
                    hint {
                      label
                      text
                    }
                    customerRole
                    artifact
                    workstream {
                      id
                      name
                      accelerator
                      activities {
                        id
                        name
                        phase
                        prescribedActions {
                          label
                          text
                        }
                        observations {
                          observations
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        actions {
                          actions {
                            text
                            priority
                            effort
                            targetDate
                            owner
                          }
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        prompts {
                          id
                          targetSegmentIds
                          label {
                            label
                            text
                          }
                          abbreviation {
                            label
                            text
                          }
                          context {
                            label
                            text
                          }
                          hint {
                            label
                            text
                          }
                          customerRole
                          artifact
                          workstream {
                            id
                            name
                            accelerator
                            score
                          }
                          dependencyActivity {
                            id
                            name
                            phase
                            score
                          }
                          responseType
                          rating1
                          rating2
                          rating3
                          rating4
                          rating5
                          questionType
                          responseSelections {
                            selectionDescription
                          }
                          priority
                          response {
                            ... on AssessmentResponseText {
                              stringValue
                              priority
                              updatedBy
                            }
                            ... on AssessmentResponseRating {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseBoolean {
                              booleanValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseNumber {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseSingleSelection {
                              singleSelectValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseMultiSelection {
                              multiSelectValues
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseDate {
                              dateValue
                              priority
                              comments
                              updatedBy
                            }
                          }
                          metadata {
                            key
                            value
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    dependencyActivity {
                      id
                      name
                      phase
                      prescribedActions {
                        label
                        text
                      }
                      observations {
                        observations
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      actions {
                        actions {
                          text
                          priority
                          effort
                          targetDate
                          owner
                        }
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      prompts {
                        id
                        targetSegmentIds
                        label {
                          label
                          text
                        }
                        abbreviation {
                          label
                          text
                        }
                        context {
                          label
                          text
                        }
                        hint {
                          label
                          text
                        }
                        customerRole
                        artifact
                        workstream {
                          id
                          name
                          accelerator
                          activities {
                            id
                            name
                            phase
                            score
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        dependencyActivity {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        responseType
                        rating1
                        rating2
                        rating3
                        rating4
                        rating5
                        questionType
                        responseSelections {
                          selectionDescription
                          selections {
                            selectionLabel
                            selectionId
                          }
                        }
                        priority
                        response {
                          ... on AssessmentResponseText {
                            stringValue
                            priority
                            updatedBy
                          }
                          ... on AssessmentResponseRating {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseBoolean {
                            booleanValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseNumber {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseSingleSelection {
                            singleSelectValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseMultiSelection {
                            multiSelectValues
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseDate {
                            dateValue
                            priority
                            comments
                            updatedBy
                          }
                        }
                        metadata {
                          key
                          value
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    responseType
                    rating1
                    rating2
                    rating3
                    rating4
                    rating5
                    questionType
                    responseSelections {
                      selectionDescription
                      selections {
                        selectionLabel
                        selectionId
                      }
                    }
                    priority
                    response {
                      ... on AssessmentResponseText {
                        stringValue
                        priority
                        updatedBy
                      }
                      ... on AssessmentResponseRating {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseBoolean {
                        booleanValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseNumber {
                        intValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseSingleSelection {
                        singleSelectValue
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseMultiSelection {
                        multiSelectValues
                        priority
                        comments
                        updatedBy
                      }
                      ... on AssessmentResponseDate {
                        dateValue
                        priority
                        comments
                        updatedBy
                      }
                    }
                    metadata {
                      key
                      value
                    }
                  }
                  score
                  booleanDistribution {
                    numYes
                    numNo
                    numUnknown
                  }
                }
                score
                booleanDistribution {
                  numYes
                  numNo
                  numUnknown
                }
              }
              dependencyActivity {
                id
                name
                phase
                prescribedActions {
                  label
                  text
                }
                observations {
                  observations
                  updatedBy
                  tags {
                    key
                    value
                  }
                }
                actions {
                  actions {
                    text
                    priority
                    effort
                    targetDate
                    owner
                  }
                  updatedBy
                  tags {
                    key
                    value
                  }
                }
                prompts {
                  id
                  targetSegmentIds
                  label {
                    label
                    text
                  }
                  abbreviation {
                    label
                    text
                  }
                  context {
                    label
                    text
                  }
                  hint {
                    label
                    text
                  }
                  customerRole
                  artifact
                  workstream {
                    id
                    name
                    accelerator
                    activities {
                      id
                      name
                      phase
                      prescribedActions {
                        label
                        text
                      }
                      observations {
                        observations
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      actions {
                        actions {
                          text
                          priority
                          effort
                          targetDate
                          owner
                        }
                        updatedBy
                        tags {
                          key
                          value
                        }
                      }
                      prompts {
                        id
                        targetSegmentIds
                        label {
                          label
                          text
                        }
                        abbreviation {
                          label
                          text
                        }
                        context {
                          label
                          text
                        }
                        hint {
                          label
                          text
                        }
                        customerRole
                        artifact
                        workstream {
                          id
                          name
                          accelerator
                          activities {
                            id
                            name
                            phase
                            score
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        dependencyActivity {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        responseType
                        rating1
                        rating2
                        rating3
                        rating4
                        rating5
                        questionType
                        responseSelections {
                          selectionDescription
                          selections {
                            selectionLabel
                            selectionId
                          }
                        }
                        priority
                        response {
                          ... on AssessmentResponseText {
                            stringValue
                            priority
                            updatedBy
                          }
                          ... on AssessmentResponseRating {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseBoolean {
                            booleanValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseNumber {
                            intValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseSingleSelection {
                            singleSelectValue
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseMultiSelection {
                            multiSelectValues
                            priority
                            comments
                            updatedBy
                          }
                          ... on AssessmentResponseDate {
                            dateValue
                            priority
                            comments
                            updatedBy
                          }
                        }
                        metadata {
                          key
                          value
                        }
                      }
                      score
                      booleanDistribution {
                        numYes
                        numNo
                        numUnknown
                      }
                    }
                    score
                    booleanDistribution {
                      numYes
                      numNo
                      numUnknown
                    }
                  }
                  dependencyActivity {
                    id
                    name
                    phase
                    prescribedActions {
                      label
                      text
                    }
                    observations {
                      observations
                      updatedBy
                      tags {
                        key
                        value
                      }
                    }
                    actions {
                      actions {
                        text
                        priority
                        effort
                        targetDate
                        owner
                      }
                      updatedBy
                      tags {
                        key
                        value
                      }
                    }
                    prompts {
                      id
                      targetSegmentIds
                      label {
                        label
                        text
                      }
                      abbreviation {
                        label
                        text
                      }
                      context {
                        label
                        text
                      }
                      hint {
                        label
                        text
                      }
                      customerRole
                      artifact
                      workstream {
                        id
                        name
                        accelerator
                        activities {
                          id
                          name
                          phase
                          prescribedActions {
                            label
                            text
                          }
                          observations {
                            observations
                            updatedBy
                          }
                          actions {
                            updatedBy
                          }
                          prompts {
                            id
                            targetSegmentIds
                            customerRole
                            artifact
                            responseType
                            rating1
                            rating2
                            rating3
                            rating4
                            rating5
                            questionType
                            priority
                          }
                          score
                          booleanDistribution {
                            numYes
                            numNo
                            numUnknown
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      dependencyActivity {
                        id
                        name
                        phase
                        prescribedActions {
                          label
                          text
                        }
                        observations {
                          observations
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        actions {
                          actions {
                            text
                            priority
                            effort
                            targetDate
                            owner
                          }
                          updatedBy
                          tags {
                            key
                            value
                          }
                        }
                        prompts {
                          id
                          targetSegmentIds
                          label {
                            label
                            text
                          }
                          abbreviation {
                            label
                            text
                          }
                          context {
                            label
                            text
                          }
                          hint {
                            label
                            text
                          }
                          customerRole
                          artifact
                          workstream {
                            id
                            name
                            accelerator
                            score
                          }
                          dependencyActivity {
                            id
                            name
                            phase
                            score
                          }
                          responseType
                          rating1
                          rating2
                          rating3
                          rating4
                          rating5
                          questionType
                          responseSelections {
                            selectionDescription
                          }
                          priority
                          response {
                            ... on AssessmentResponseText {
                              stringValue
                              priority
                              updatedBy
                            }
                            ... on AssessmentResponseRating {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseBoolean {
                              booleanValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseNumber {
                              intValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseSingleSelection {
                              singleSelectValue
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseMultiSelection {
                              multiSelectValues
                              priority
                              comments
                              updatedBy
                            }
                            ... on AssessmentResponseDate {
                              dateValue
                              priority
                              comments
                              updatedBy
                            }
                          }
                          metadata {
                            key
                            value
                          }
                        }
                        score
                        booleanDistribution {
                          numYes
                          numNo
                          numUnknown
                        }
                      }
                      responseType
                      rating1
                      rating2
                      rating3
                      rating4
                      rating5
                      questionType
                      responseSelections {
                        selectionDescription
                        selections {
                          selectionLabel
                          selectionId
                        }
                      }
                      priority
                      response {
                        ... on AssessmentResponseText {
                          stringValue
                          priority
                          updatedBy
                        }
                        ... on AssessmentResponseRating {
                          intValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseBoolean {
                          booleanValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseNumber {
                          intValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseSingleSelection {
                          singleSelectValue
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseMultiSelection {
                          multiSelectValues
                          priority
                          comments
                          updatedBy
                        }
                        ... on AssessmentResponseDate {
                          dateValue
                          priority
                          comments
                          updatedBy
                        }
                      }
                      metadata {
                        key
                        value
                      }
                    }
                    score
                    booleanDistribution {
                      numYes
                      numNo
                      numUnknown
                    }
                  }
                  responseType
                  rating1
                  rating2
                  rating3
                  rating4
                  rating5
                  questionType
                  responseSelections {
                    selectionDescription
                    selections {
                      selectionLabel
                      selectionId
                    }
                  }
                  priority
                  response {
                    ... on AssessmentResponseText {
                      stringValue
                      priority
                      updatedBy
                    }
                    ... on AssessmentResponseRating {
                      intValue
                      priority
                      comments
                      updatedBy
                    }
                    ... on AssessmentResponseBoolean {
                      booleanValue
                      priority
                      comments
                      updatedBy
                    }
                    ... on AssessmentResponseNumber {
                      intValue
                      priority
                      comments
                      updatedBy
                    }
                    ... on AssessmentResponseSingleSelection {
                      singleSelectValue
                      priority
                      comments
                      updatedBy
                    }
                    ... on AssessmentResponseMultiSelection {
                      multiSelectValues
                      priority
                      comments
                      updatedBy
                    }
                    ... on AssessmentResponseDate {
                      dateValue
                      priority
                      comments
                      updatedBy
                    }
                  }
                  metadata {
                    key
                    value
                  }
                }
                score
                booleanDistribution {
                  numYes
                  numNo
                  numUnknown
                }
              }
              responseType
              rating1
              rating2
              rating3
              rating4
              rating5
              questionType
              responseSelections {
                selectionDescription
                selections {
                  selectionLabel
                  selectionId
                }
              }
              priority
              response {
                ... on AssessmentResponseText {
                  stringValue
                  priority
                  updatedBy
                }
                ... on AssessmentResponseRating {
                  intValue
                  priority
                  comments
                  updatedBy
                }
                ... on AssessmentResponseBoolean {
                  booleanValue
                  priority
                  comments
                  updatedBy
                }
                ... on AssessmentResponseNumber {
                  intValue
                  priority
                  comments
                  updatedBy
                }
                ... on AssessmentResponseSingleSelection {
                  singleSelectValue
                  priority
                  comments
                  updatedBy
                }
                ... on AssessmentResponseMultiSelection {
                  multiSelectValues
                  priority
                  comments
                  updatedBy
                }
                ... on AssessmentResponseDate {
                  dateValue
                  priority
                  comments
                  updatedBy
                }
              }
              metadata {
                key
                value
              }
            }
            score
            booleanDistribution {
              numYes
              numNo
              numUnknown
            }
          }
          score
          booleanDistribution {
            numYes
            numNo
            numUnknown
          }
        }
        progress
        score
        booleanDistribution {
          numYes
          numNo
          numUnknown
        }
        deliveryGuidance {
          description
          learnMore
        }
        metadataConfig {
          excludeOptionalMetadataKeys
          requiredMetadataKeys
          customMetadata {
            key
            keyName
            keyDescription
            valueType
            valueHint
            defaultValue
            responseSelections {
              selectionDescription
              selections {
                selectionLabel
                selectionId
              }
            }
          }
        }
      }
      nextToken
    }
  }
`;
exports.getAssessmentFeatures = `
  query GetAssessmentFeatures($limit: Int, $nextToken: AWSJSON) {
    getAssessmentFeatures(limit: $limit, nextToken: $nextToken) {
      items
      nextToken
    }
  }
`;
exports.getOrgAssessmentSummary = `
  query GetOrgAssessmentSummary($limit: Int, $nextToken: AWSJSON) {
    getOrgAssessmentSummary(limit: $limit, nextToken: $nextToken)
  }
`;
exports.getCustomizedPrescribedActions = `
  query GetCustomizedPrescribedActions(
    $filter: CustomizedPrescribedActionsInputFilter!
    $nextToken: AWSJSON
  ) {
    getCustomizedPrescribedActions(filter: $filter, nextToken: $nextToken) {
      allPrescribedActions {
        type
        actionId
        prescribedActions {
          label
          text
        }
      }
      nextToken
    }
  }
`;
